import React from 'react'
import PropTypes from 'prop-types'

import { useMakeSelector } from 'hooks/redux'
import { makeGetHasErrors } from 'selectors/validation'

import strings from 'utils/strings'
import { isNativeOutput, isCanOutput, isPinOutput } from 'utils/types/features'

import { outputTypeLabels } from 'i18n/displayConstants/featureOutputs'
import ParameterValue from 'components/ParameterValue'

import { CAN, PIN } from 'utils/constants'

import OutputTypeNativeDescriptionLabel from './OutputTypeNativeDescriptionLabel'

const getOutputLabel = ({
  mappedOutputId,
  type,
  outputDescription,
  description,
  connector,
  location,
  numberOfBits,
}) => {
  if (mappedOutputId) {
    if (isPinOutput(type)) {
      return {
        label: outputTypeLabels[PIN],
        value: `${outputDescription || description}: ${connector}-${location}`,
      }
    }
    if (isCanOutput(type)) {
      return {
        label: `${outputTypeLabels[CAN]} ${numberOfBits} ${strings.bit}`,
        value: `${outputDescription || mappedOutputId}`,
      }
    }
  }

  return null
}

const OutputTypeDescriptionLabel = ({
  id,
  fnId,
  mappedOutputId,
  type,
  outputDescription,
  description,
  connector,
  location,
  numberOfBits,
}) => {
  const hasErrors = useMakeSelector(makeGetHasErrors, { id })

  const paramValue = getOutputLabel({
    id,
    mappedOutputId,
    type,
    outputDescription,
    description,
    connector,
    location,
    numberOfBits,
  })

  if (hasErrors && !paramValue) {
    return strings.no_input_selected
  }

  if (isNativeOutput(type)) {
    return (
      <OutputTypeNativeDescriptionLabel
        fnId={fnId}
        outputDescription={outputDescription}
        description={description}
      />
    )
  }

  return (
    paramValue && (
      <ParameterValue
        label={paramValue.label}
        value={paramValue.value}
        size="small"
      />
    )
  )
}

OutputTypeDescriptionLabel.propTypes = {
  id: PropTypes.string,
  fnId: PropTypes.string,
  mappedOutputId: PropTypes.string,
  type: PropTypes.string,
  outputDescription: PropTypes.string,
  description: PropTypes.string,
  connector: PropTypes.string,
  location: PropTypes.string,
  numberOfBits: PropTypes.number,
}

export default OutputTypeDescriptionLabel
